import { createRouter, createWebHashHistory } from 'vue-router'
import store from 'shared/store/index';

const Index = () => import(/* webpackChunkName: "bicycle-exemption-pages" */ 'app/bicycle-exemption/pages/Index')
const Form = () => import(/* webpackChunkName: "bicycle-exemption-pages" */ 'app/bicycle-exemption/pages/Form')

const routes = [
  {
    path: '/',
    component: Index,
    name: 'index',
    redirect: '/1',
    children: [
      {
        path: '/:step',
        name: 'step',
        component: Form
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const step = Number(to.params && to.params.step ? to.params.step : 1);
  const canNavigate = store.getters['bicycle-exemption/completedPreviousStep'](step);

  if (canNavigate) next();
  else next({ path: '/' });
});

export default router;
